import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';

const API = process.env.REACT_APP_API_URL;

export default function OfertasAdmin() {
  const [ofertas, setOfertas] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { load(); }, []);

  const load = async () => {
    try {
      const res = await fetch(`${API}/prod/ofertas_admin`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'list' }),
      });
      const data = await res.json();
      const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body || data;
      setOfertas(Array.isArray(body) ? body : []);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const updateCashback = async (id, value) => {
    try {
      await fetch(`${API}/prod/ofertas_admin`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'update', idoferta_app: id, cashback_pct: parseFloat(value) || 0 }),
      });
      toast.success(`🍌 Oferta ${id} actualizada: $${value} cashback`);
      load();
    } catch { toast.error('Error al actualizar'); }
  };

  if (loading) return <div style={{ padding: 20, textAlign: 'center', color: '#9ca3af' }}>Cargando ofertas...</div>;

  return (
    <div style={{ marginTop: '20px' }}>
      <h2>🍌 Ofertas & Banana Pesos</h2>

      <div style={{ background: '#fef9c3', borderRadius: '14px', padding: '14px', marginBottom: '20px', fontSize: '13px', color: '#92400e', lineHeight: '1.5' }}>
        <strong>Configura cuántos banana pesos gana el cliente por cada oferta.</strong>
        <br />Si pones $0, esa oferta no da cashback. Si usa banana pesos para pagar, no gana cashback en esa compra.
      </div>

      <div style={{ maxHeight: '500px', overflowY: 'auto' }}>
        {ofertas.map(o => (
          <div key={o.idoferta_app} style={{
            display: 'flex', alignItems: 'center', gap: '12px',
            padding: '12px 14px', background: '#fff', borderRadius: '12px',
            marginBottom: '8px', border: '1px solid #e2e8f0',
          }}>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontWeight: 700, fontSize: 14, color: '#1b2938' }}>
                {o.nombre_comercial || `Oferta ${o.idoferta_app}`}
              </div>
              <div style={{ fontSize: 12, color: '#6b7280', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                ${o.precion_minorista} · {o.descripcion_oferta_comercial?.substring(0, 40)}...
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexShrink: 0 }}>
              <span style={{ fontSize: '18px' }}>🍌</span>
              <input
                type="number"
                defaultValue={o.cashback_pct || 0}
                min="0"
                step="1"
                style={{
                  width: '60px', padding: '8px', borderRadius: '8px',
                  border: '1px solid #ccc', fontSize: '14px', textAlign: 'center',
                }}
                onBlur={(e) => {
                  const val = e.target.value;
                  if (parseFloat(val) !== (o.cashback_pct || 0)) {
                    updateCashback(o.idoferta_app, val);
                  }
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <div style={{ height: 80 }} />
    </div>
  );
}
